export default {
    contactUs: 'Kontaktirajte nas',
    contact: 'Kontakt',
    blogTitle: 'Gradimo prihodnost v negi nasmeha',
    blogDescription:
        'Razvijamo izdelke na podlagi prepričanja, da je beljenje zob lahko učinkovito in varno.',
    blogButton: 'Prikaži vse',
    allAboutHelloCoco: 'Vse o hello coco',
    aboutUs: 'O nas',
    reviews: 'Ocene',
    reviewsLink: '/recenze/',
    cocoEmail: 'kontakt@hellococo.cz',
    termsAndConditions: 'Splošni pogoji',
    termsAndConditionsLink: '/obchodni-podminky/',
    privacyPolicy: 'Varstvo osebnih podatkov',
    privacyPolicyLink: '/ochrana-soukromi/',
    purchase: 'Nakup',

    emptyCartText: 'Košarica čaka na vaše prve odkritja - poglejte našo ponudbo!',
    startShopping: 'Začni nakupovati',

    orderSummary: 'Povzetek naročila',
    shippingAndPayment: 'Dostava in plačilo',
    discountCoupon: 'Popustni kupon',
    applyDiscount: 'Uporabi',
    giftsHeading: 'Izberite BREZPLAČNO darilo',

    orderInfo: 'Vaše informacije',
    orderNumber: 'Številka naročila',

    'header.others': 'Drugo',
    'header.categories': 'Kategorije',
    'header.followUs': 'Spremljajte nas',

    'emptyCart.title': 'Vaša košarica je prazna',
    'emptyCart.backToShop': 'Nazaj v trgovino',

    show_all: 'Prikaži vse',

    'login.title': 'Prijava na svoj račun',
    'login.button': 'Prijava',
    'login.forgotPassword': 'Pozabi geslo',
    'login.createAccount': 'Ustvari račun',

    'global.freeDelivery': 'Imate brezplačno dostavo!',

    'filter.recommended': 'Priporočamo',
    'filter.leastExpensive': 'Najcenejši',
    'filter.mostExpensive': 'Najdražji',
    'filter.alphabetically': 'Abecedno',

    aboutUsLink: '/o-nas/',
    contactUsLink: '/kontaktirajte-nas/',

    'email.placeholder': 'Vnesite svoj e-poštni naslov',

    'instagram.title': 'Strokovnjaki za nego nasmeha @hellococo_si',
    'instagram.url': 'https://www.instagram.com/hellococo_si/',
    'facebook.url': 'https://www.facebook.com/hellococobrand/',
}
